<script setup lang="ts">
import type { ReportTemplate } from "@/types/report-templates.types";
import DrawerContentSection from "../DrawerContentSection.vue";
import TemplateMetadataDetectorItem from "./TemplateMetadataDetectorItem.vue";
import { computed } from "vue";

const props = defineProps<{
  template: ReportTemplate;
}>();

const orderedMetadataDetectors = computed(() => {
  if (!props.template.metadataDetectors) return [];
  const detectors = [...props.template.metadataDetectors];
  const res = detectors.sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );
  return res;
});
</script>

<template>
  <div class="d-flex flex-column gap-5">
    <DrawerContentSection
      :title="$t('dashboard:templates.drawer.sections.dynamicFields.title')"
      :description="
        $t('dashboard:templates.drawer.sections.dynamicFields.description')
      "
    >
      <div class="d-flex flex-column gap-3">
        <TemplateMetadataDetectorItem
          v-for="metadata in orderedMetadataDetectors"
          :key="metadata.id"
          :metadata-detector="metadata"
        />
      </div>
    </DrawerContentSection>
  </div>
</template>

<style lang="scss" scoped></style>
